import GetSafetyHookLookupRequestModelBase from '../_generated/modelBases/get-safety-hook-lookup-request-model-base';

export default class GetSafetyHookLookupRequestModel extends GetSafetyHookLookupRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
